import React, { useEffect } from "react";

import { gsap } from "gsap";

const WEevolve = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    gradient: {
      background:
        "linear-gradient(270deg, rgba(195,34,34,1) 0%, rgba(118,45,253,1) 100%)",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  useEffect(() => {
    gsap.fromTo(
      ".section",
      {
        autoAlpha: 0,
        y: 100,
      },
      {
        autoAlpha: 1,
        y: 0,
        ease: "expo.inOut",
        duration: 1,
        stagger: 0.1,
      }
    );
  });

  return (
    <div className="w-full h-full text-white " style={styles.blackbg}>
      <div className="w-full max-w-2xl m-auto py-8 px-4">
        <div className="text-xl section" style={styles.blueText}>
          AIESEC in SLIIT
        </div>
        <div className="text-4xl font-bold section">
          <div className="p-4 rounded-lg" style={styles.gradient}>
            WEvolve
          </div>
          <div className="text-2xl">#BreakTheSilence</div>
        </div>

        <div className="text-xl mt-1 text-gray-400 section">
          Application Package
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Event Introduction</div>
          <p className="text-gray-400">
            <span className="rounded-md" style={styles.gradient}>
              &nbsp;WEvolve&nbsp;
            </span>{" "}
            is an event organized by AIESEC in SLIIT focusing on one of the less
            spoken topics in society, which is Mental Health and Wellbeing.
            Creating awareness among everyone while raising a voice for anyone
            going through hardships that affect them mentally and making an
            impact on society by giving a hand to the ones in need will be the
            main objective of this event.
          </p>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Timeline</div>
          <div>
            <span className="font-bold">Application Open - </span>{" "}
            <span className="text-gray-300">6th November</span> <br />
            <span className="font-bold">Application Deadline - </span>{" "}
            <span className="text-gray-300">11th November</span> <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Team Structure</div>
          <div>
            <span className="">OCVP Delegates x1</span> <br />
            <span className="">OCVP Marketing x3</span> <br />
            <span className="">OCVP External Relations x1</span> <br />
            <span className="">OCVP Finance x1</span> <br />
            <span className="">OCVP Events x1</span> <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Available Roles</div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #0373f3" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#0373f3" }}
            >
              OCVP Delegates <span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Being the first touchpoint between Felicity delegates and
                  AIESEC in SLIIT
                </li>
                <li>
                  Setting up expectation setting and internal briefing about the
                  requirements.
                </li>
                <li>Answering all the inquiries from the participants</li>
                <li>Creating and managing a database of the participants.</li>
                <li>Managing invitations of participants.</li>
                <li>Managing the registrations of the participants.</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in Coordinating and negotiating with people</li>
                <li>Experience in event management and coordination</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #F85A40" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#F85A40" }}
            >
              OCVP Marketing<span className="text-gray-500"> x3</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Planning event marketing timeline.</li>
                <li>Creating and implementing marketing strategies.</li>
                <li>Increasing virtual outreach through various platforms.</li>
                <li>Managing digital marketing materials & tools.</li>
                <li>Collect content for showcasing.</li>
                <li>Content creation and comprehensive writing skills.</li>
                <li>Follow up with the agenda.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Experience in partnership management with variety of
                  Stakeholders
                </li>
                <li>Experience in planning and running marketing campaigns</li>
                <li>
                  Experience on designing promotional material for an event
                </li>
                <li>Experience in photo editing and video editing software.</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #FFC845" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#FFC845" }}
            >
              OCVP External Relations
              <span className="text-gray-500"> x3</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Develop partnerships with organizations in order to get
                  monetary or in-kind support.
                </li>
                <li>Current External Relations accounts management.</li>
                <li>Creating and implementing ER strategies.</li>
                <li>
                  Identify potential Companies/Organisations and get onboard.
                </li>
                <li>Online, print & digital media partnerships.</li>
                <li>Responsible for the deliveries of the partnerships.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>Partnership Management.</li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>
                  Market research experience of partnership management with a
                  variety of stakeholders
                </li>
                <li>Experience on event management and sales</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #0CB9C1" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#0CB9C1" }}
            >
              OCVP Public Relations<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Develop partnerships with stakeholders & NGOs.</li>
                <li>Current Public Relations accounts management.</li>
                <li>Creating and implementing PR strategies.</li>
                <li>Identify potential Organisations and get onboard.</li>
                <li>Public figures handling.</li>
                <li>Responsible for the contents published on media.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
                <li>Partnership Management.</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in Partnership Management</li>
                <li>
                  Experience in People Handling and negotiating and
                  coordination.
                </li>
                <li>Clear and effective communication.</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #F85A40" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#F85A40" }}
            >
              OCVP Finance<span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Manage the finance of the event.</li>
                <li>Cash Flow management of the event.</li>
                <li>Preparing necessary budgets and reports.</li>
                <li>Responsible for budget execution.</li>
                <li>Preparing final finance report.</li>
                <li>
                  Understanding and addressing synergy points with other
                  positions as required.
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in event planning and management</li>
                <li>
                  Experience in attention to detail and working under pressure
                </li>
                <li>Professional communication skills</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div
            className="w-full rounded-lg border p-2"
            style={{ border: "2px solid #0373f3" }}
          >
            <div
              className="text-center text-2xl font-bold"
              style={{ color: "#0373f3" }}
            >
              OCVP Events<span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Identifying the logistical requirements.</li>
                <li>Delivering the Model of the Event.</li>
                <li>
                  Finding the most appropriate ways to fulfill logistic
                  requirements.
                </li>
                <li>
                  Preparation and coordination of the event agenda and event
                  flow.
                </li>
                <li>Speakers management.</li>
                <li>Responsible for the smooth flow of the event.</li>
                <li>
                  Research to improve the online delegate experience and
                  engagement
                </li>
                <li>
                  Performing additional duties related to the project set out by
                  the OCP.
                </li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in event planning and management.</li>
                <li>
                  Experience in attention to detail and working under pressure.
                </li>
                <li>Professional communication skills.</li>
              </ul>
            </div>
          </div>
          {/** Contact Info ***/}
          <div className="mt-8">
            <div className="w-full h-1 bg-gray-700 mb-8"></div>
            <div className="text-2xl mb-4 font-semibold">Contact Info</div>
            <div>
              <div>For any clarifications, </div>
              <div style={styles.blueText} className="text-3xl">
                Pasindu Gunasekara
              </div>
              <div className="text-gray-400">OEVP oGT PS – AIESEC in SLIIT</div>
              <div className="text-gray-400">pasindu.gunasekara@aiesec.net</div>
              <div className="text-gray-400">+94 76 623 4615</div>
            </div>
          </div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScXxau3sCgdu_6yo6i_GkdtBlxVambdigzMB03X1ocurt01bQ/viewform"
            target="_blank"
            rel="noreferrer"
          >
            <div
              className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer"
              style={{ background: "#037ef3" }}
            >
              Apply
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default WEevolve;
